import { render, staticRenderFns } from "./CWComments.vue?vue&type=template&id=8ea3e92c&scoped=true&"
import script from "./CWComments.vue?vue&type=script&lang=js&"
export * from "./CWComments.vue?vue&type=script&lang=js&"
import style0 from "./CWComments.vue?vue&type=style&index=0&id=8ea3e92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea3e92c",
  null
  
)

export default component.exports